import { ErrorView } from "@/components/error-view";
import { useLang } from "@/hooks/use-lang";

import { DataGrid } from "ui/widget/data-grid";

import { HoldingsInfoList } from "../../../data/holdings-info";
import { useHoldingsInfoTable } from "../../../hooks/use-holdings-info-table";
import { HoldingsInfo } from "../../../services/get-investor-holdings-info";

type Props = {
  investor: string;
  initialData: HoldingsInfo;
  selectedCategoryIndex: number;
};

export const HoldingsInfoTable = ({
  investor,
  initialData,
  selectedCategoryIndex,
}: Props) => {
  const { t, lang } = useLang();
  const { table, isFetching } = useHoldingsInfoTable({
    investor,
    category: HoldingsInfoList[selectedCategoryIndex],
    initialData,
  });

  return (
    <DataGrid
      maxTableHeight={410}
      aria-label="holdings info table"
      table={table}
      className="text-sm max-sm:mb-4"
      headClassName="h-8 bg-slate-50 first:[&>th]:bg-slate-50"
      bodyClassName="divide-y divide-gray-200"
      rowClassName="h-9 hover:bg-slate-50 first:[&>td]:bg-white first:[&>td]:hover:bg-slate-50"
      stickyColumn={true}
      enablePagination
      isLoading={isFetching}
      rowsPerPage={[10, 25, 50, 100]}
      emptyView={<ErrorView errorType="empty">{t.error.noData}</ErrorView>}
      lang={lang}
    />
  );
};
